import axios from 'axios';

// Remover API_URL e usar import.meta.env diretamente
// const API_URL = '/api'; 

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

export interface LoginData {
  email: string;
  password: string;
}

export interface User {
  id: number;
  name: string;
  email: string;
  profile_id?: number;
  profile?: {
    id: number;
    name: string;
    permissions: Record<string, boolean>;
  }
}

export interface AuthResponse {
  token: string;
  user: User;
}

export const login = async (data: LoginData): Promise<AuthResponse> => {
  console.log('[authService.login] Valor de VITE_API_BASE_URL:', import.meta.env.VITE_API_BASE_URL);
  console.log("[authService.login] Iniciando chamada POST para /api/auth/login");
  // Usar a variável de ambiente + caminho específico
  const response = await axios.post<AuthResponse>(`${API_BASE_URL}/api/auth/login`, data);
  
  if (response.data && response.data.token) {
    console.log("[authService.login] Login API bem-sucedido. Salvando token e user no localStorage.");
    // Salva token e usuário básico. As permissões serão gerenciadas pelo AuthContext.
    localStorage.setItem('token', response.data.token);
    localStorage.setItem('user', JSON.stringify(response.data.user)); 
  } else {
    console.warn("[authService.login] Resposta da API de login inválida ou sem token.");
    // Lançar um erro ou retornar a resposta como está, dependendo do tratamento de erro desejado.
  }
  
  // Retorna a resposta completa para o AuthProvider usar
  return response.data; 
};

export const logout = (): void => {
  console.log("[authService.logout] Removendo itens do localStorage.");
  localStorage.removeItem('token');
  localStorage.removeItem('user');
  localStorage.removeItem('permissions'); // Ainda remove, caso exista algum lixo
};

export const getCurrentUser = (): User | null => {
  const userStr = localStorage.getItem('user');
  if (!userStr) return null;
  
  try {
    return JSON.parse(userStr);
  } catch (error) {
    console.error('Erro ao parsear dados do usuário:', error);
    return null;
  }
};

export const getStoredPermissions = (): Record<string, boolean> => {
  const permissionsStr = localStorage.getItem('permissions');
  if (!permissionsStr) return {};

  try {
    return JSON.parse(permissionsStr);
  } catch (error) {
    console.error('Erro ao parsear permissões:', error);
    return {};
  }
};

export const hasPermission = (permissionKey: string): boolean => {
  const permissions = getStoredPermissions();
  return permissions[permissionKey] === true;
};

export const isAuthenticated = (): boolean => {
  return !!localStorage.getItem('token');
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

// Adiciona o token de autenticação a todas as requisições
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (!config.headers['Content-Type']) {
        config.headers['Content-Type'] = 'application/json';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptador de resposta para lidar com erros de autenticação (ex: token expirado)
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      console.warn('Recebido erro 401. Deslogando usuário.');
      logout();
      window.location.href = '/login'; 
    }
    return Promise.reject(error);
  }
); 